<template>
  <div class="scrollbar" ref="scrollbar">
    <slot />
  </div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";

export default {
  name: "Scrollbar",
  props: {
    options: {
      type: Object,
      default: () => ({
        handlers: ["keyboard", "wheel", "touch", "click-rail", "drag-thumb"]
      })
    }
  },
  data() {
    return {
      ps: null,
      container: null
    };
  },
  mounted() {
    this.container = this.$refs["scrollbar"];
    this.ps = new PerfectScrollbar(this.container, this.options);
  },
  destroyed() {
    this.ps.destroy();
    this.ps = null;
  }
};
</script>

<style lang="scss" scoped>
.scrollbar {
  position: relative;
}
</style>
